import BaseAPI from "./BaseAPI";

class RolesAPI extends BaseAPI {
	
    index = async () => {
        var promise = null;
        promise = await this.init().get("/account/roles");
        return promise;
    };

	get = async (key) => {
        var promise = null;
            promise = await this.init().get("/account/roles/"+key);
        return promise;
    };

    getforuser = async (userid) => {
        var key = userid;
        if(!userid || userid == '') {
            key = "init";
        }
        
        var promise = null;
            promise = await this.init().get("/account/roles/foruser/"+key);
        return promise;
    };

    store = async (data) => {
        var promise = null;
            promise = await this.init().post("/account/roles", data);
        return promise;
    };

    delete = async (key) => {
        var promise = null;
            promise = await this.init().delete("/account/roles/"+key);
        return promise;
    };

}

export default new RolesAPI();